import React, { useState, useEffect } from "react";
// REMOVED: axios, domain, token imports
import { EmployeePickerField } from "../../../../../common/selectComponents/EmployeePicker";
import { TextArea } from "../../../../../common/Input";
import CloseIcon from "@mui/icons-material/Close";
import MedicalInformationIcon from '@mui/icons-material/MedicalInformation';

// MODIFIED: Receives availableReqs and getAssignmentDetails via props from the hook/parent
const MedicalClearanceAssignmentModal = ({
  isOpen,
  onClose,
  onSave,
  loading,
  selectedData,
  availableReqs = [],
  getAssignmentDetails
}) => {
  const [form, setForm] = useState({
    employeePersonalInformationId: "",
    employeeName: "",
    requirementIds: [],
    remarks: ""
  });

  useEffect(() => {
    if (isOpen) {
      if (selectedData) {
        loadExistingDetails();
      } else {
        setForm({ employeePersonalInformationId: "", employeeName: "", requirementIds: [], remarks: "" });
      }
    }
  }, [isOpen, selectedData]);

  // MODIFIED: Uses the function provided by the hook instead of direct axios
  const loadExistingDetails = async () => {
    const details = await getAssignmentDetails(selectedData.id);
    if (details) {
      setForm({
        employeePersonalInformationId: selectedData.employeePersonalInformationId,
        employeeName: selectedData.employeeFullName,
        remarks: selectedData.remarks || "",
        requirementIds: details.map(d => d.clinicRequirementId)
      });
    }
  };

  const toggleRequirement = (id) => {
    setForm(prev => ({
      ...prev,
      requirementIds: prev.requirementIds.includes(id)
        ? prev.requirementIds.filter(i => i !== id)
        : [...prev.requirementIds, id]
    }));
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-4" style={{ marginTop: "0px" }}>
      <div className="bg-white w-full max-w-2xl rounded-lg shadow-2xl flex flex-col max-h-[90vh]">
        <div className="flex justify-between rounded-t-lg items-center p-4 border-b bg-gray-50">
          <h3 className="font-bold text-gray-600 flex items-center gap-2">
            <MedicalInformationIcon className="text-blue-600" />
            {selectedData ? "Edit Draft Assignment" : "New Medical Clearance Assignment"}
          </h3>
          <button onClick={onClose} className="bg-transparent border-none cursor-pointer"><CloseIcon /></button>
        </div>

        <div className="p-6 space-y-4 overflow-y-auto">
          <EmployeePickerField
            label="Target Employee"
            isRequired={true}
            employeePersonalInformationId={form.employeePersonalInformationId}
            displayValue={form.employeeName}
            onSelect={(emp) => setForm({ ...form, employeePersonalInformationId: emp.id, employeeName: emp.fullName })}
            viewMode={!!selectedData}
          />

          <div className="border rounded-lg p-4 bg-gray-50">
            <span className="font-bold text-sm text-gray-600 block mb-3">Select Clinic Requirements</span>
            <div className="grid grid-cols-2 gap-3">
              {availableReqs.map(req => (
                <label key={req.id} className="flex items-center gap-2 p-2 bg-white border rounded hover:bg-blue-50 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={form.requirementIds.includes(req.id)}
                    onChange={() => toggleRequirement(req.id)}
                  />
                  <span className="text-xs">{req.description}</span>
                </label>
              ))}
            </div>
          </div>

          <TextArea label="Remarks" value={form.remarks} onChange={(e) => setForm({ ...form, remarks: e.target.value })} rows={2} />
        </div>

        <div className="p-4 border-t bg-gray-50 flex justify-end gap-2">
          <button onClick={onClose} className="px-6 py-2 bg-gray-400 text-white rounded border-none cursor-pointer">Cancel</button>
          <button
            disabled={loading || !form.employeePersonalInformationId || form.requirementIds.length === 0}
            onClick={() => onSave(form)}
            className="px-8 py-2 bg-blue-600 text-white rounded border-none cursor-pointer font-bold"
          >
            {loading ? "Saving..." : "Save Assignment"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MedicalClearanceAssignmentModal;